import React from "react";
import { PaziaButton, PaziaButtonType } from "./PaziaButton";
import { Link } from "react-router-dom";

interface PaziaLinkButtonProps {
  href: string;
  type: PaziaButtonType;
  children?: React.ReactNode;
}

export const PaziaLinkButton = ({
  href,
  type,
  children,
}: PaziaLinkButtonProps): JSX.Element => {
  return (
    <Link to={href}>
      <PaziaButton type={type} btnType="button">
        {children}
      </PaziaButton>
    </Link>
  );
};
